import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useAuth } from '../../contexts/AuthContext';
import { BackendServerURL } from '../../constants';
import { Redirect } from 'react-router-dom';
import Lottie from 'react-lottie-player';
import lottieJson from "../../images/loadingBlack.json";

function SubscribtionPage(props) {
    const {
      currentUser, 
      stripeId, 
      checkSubscriptionFirebase, 
      setSubscriptionId,
      subscribed,
    } = useAuth();
    const [message, setMessage] = useState('Sending payment...(Please dont close this page)');
    const [redirect, setRedirect] = useState(null);
    const [showButton, setShowButton] = useState(false);

    useEffect(async() => {
        if(currentUser){
            if(!stripeId ){
                await checkSubscriptionFirebase(currentUser.uid);
            }
            if(subscribed === 1){
              // Toast message Already Subscriped
              setRedirect("/dashboard")
              return;
            }
            if(props.location.state && props.location.state.priceId){
              await fetch(BackendServerURL + '/create-subscription', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  customerId: stripeId,
                  priceId:props.location.state.priceId,
                }),
              }).then(r => r.json()).then(({subscription}) => {
                if(subscription){
                  setSubscriptionId(subscription.id)
                  setMessage(`Subscription Created (Redirecting...)`);
                  setTimeout(() => {
                    if(subscription.status && subscription.status === 'active'){
                      setRedirect("/dashboard")
                    }
                  }, 3000);
                }
              }).catch(error => {
                setMessage(error.message);
                setShowButton(true);
                setTimeout(() => {setRedirect("/prices")}, 3000);
              });
            }else{
              return;
            }
            
        }
        
    }, [stripeId, currentUser, props])

    useEffect(() => {
      document.documentElement.style.setProperty("--background", "#000");
      window.onunload = function () {
        document.documentElement.style.setProperty("--background", "#fff");
      };
      window.addEventListener('beforeunload', alertUser)
      return () => {
          window.removeEventListener('beforeunload', alertUser)
      }
    }, [])

    const alertUser = e => {
        e.preventDefault()
        e.returnValue = ''
    }

    if(redirect){
        return <Redirect to={redirect}/>
    }

    return (
        <div>
            <div className="loading-wrapper">
          <Lottie
            loop
            animationData={lottieJson}
            play
            style={{ width: 150, height: 150 }}
          />
          <span
            style={{
              fontSize: "14px",
              color:"white"
            }}
          >
            {message}
            {showButton ?
            <div className='addCardWrapper'>
              <button className='addCardWrapper' onClick={() => setRedirect("/prices")}>Go Back</button>
            </div>
             : null}
          </span>
        </div>
        </div>
    );
}

SubscribtionPage.propTypes = {

}

export default SubscribtionPage
